import Icon from "@material-ui/icons/LocalAtm";
import Create from "./CcaRateChartCreate";
import Show from "./CcaRateChartShow";
import Edit from "./CcaRateChartUpdate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaRateCharts",
  create: Create,
  show: Show,
  edit: Edit,
  icon: Icon,
};
